export enum CharacterState {
  CORRECT = "CORRECT",
  WRONG = "WRONG",
  NORMAL = "NORMAL",
}

export enum HTTP_METHODS {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE"
}

